module.exports = __webpack_public_path__ + "static/media/hobbies.6133f1de.webp";